import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/Mac/Banner';
import Demo from '../Components/Pages/Mac/Demo';
import Header from '../Components/Shared/Header/Header';
import Features1 from '../Components/Pages/MobileApp/Features';
import Features from '../Components/Pages/Home/Features';
import Innovative from '../Components/Pages/Home/Innovative';
import Jobs from '../Components/Pages/AboutUs/Jobs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import Section from '../Components/Pages/Mac/Section';
import Design from '../Components/Pages/Mac/Design';
import FaqApp from '../Components/Shared/FaqApp/FaqApp';
import Slider from '../Components/Shared/LogoSlider/Slider';
import { images } from '../Components/Pages/Home/data';
function Mac(){
  useEffect(() => {
    AOS.init({
      duration: 800,
      disable: 'mobile',
      once: true,
    });
  }, []);
    return(
        <>
        <Header />
        <Banner />
        <Demo />
        <Features1 />
        <Innovative />
        <Section />
        <Design />
        <FaqApp />
        <Slider list={images}  styles="nobg-slider"/>
      <Features />
      <Jobs />
      <Start />
      <Footer/>
        </>
    )
};
export default Mac ;